import type { CareerTierId } from '@crowdfpl/domain/gamification';
import {
  Brain,
  ClipboardList,
  Crown,
  Dices,
  type LucideIcon,
  ScanSearch,
  Sprout,
} from 'lucide-react';

export const CAREER_TIER_ICONS: Record<CareerTierId, LucideIcon> = {
  rookie: Sprout,
  scout: ScanSearch,
  punter: Dices,
  gaffer: ClipboardList,
  mastermind: Brain,
  legend: Crown,
};
